/* Kaori product page: gallery, 3-for deal builder, bulk scent picker, options, sticky bar. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(root) {
    if (!root || root.dataset.kpReady) return;
    root.dataset.kpReady = '1';
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var unit = parseInt(root.getAttribute('data-unit'), 10) || 1000;
    var need = parseInt(root.getAttribute('data-qty'), 10) || 3;
    var dealPrice = parseInt(root.getAttribute('data-deal'), 10) || 2000;
    var pickCount = parseInt(root.getAttribute('data-pick'), 10) || 0;
    var cur = root.getAttribute('data-currency') || '£';
    var addUrl = root.getAttribute('data-cart-add') + '.js';
    function money(p) { var v = p / 100; return cur + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }

    /* ---------- Gallery ---------- */
    var track = $('[data-kp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = $$('[data-kp-thumb]');
    var prev = $('[data-kp-prev]'), next = $('[data-kp-next]');
    var idxEl = $('[data-kp-index]'), totEl = $('[data-kp-total]');
    var gi = 0;
    if (totEl) totEl.textContent = slides.length;
    if (slides.length < 2) { [prev, next, $('.kp__count'), $('.kp__thumbs')].forEach(function (n) { if (n) n.style.display = 'none'; }); }
    function syncGallery() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i === gi && slides[i] && slides[i].classList.contains('is-current')) return;
      gi = Math.max(0, Math.min(i, slides.length - 1));
      slides.forEach(function (s, k) { s.classList.toggle('is-current', k === gi); if (k !== gi) s.classList.remove('is-zoom'); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === gi); });
      if (thumbs[gi]) thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      if (idxEl) idxEl.textContent = gi + 1;
      if (prev) prev.disabled = gi === 0;
      if (next) next.disabled = gi === slides.length - 1;
    }
    function goTo(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    if (track && slides.length) {
      slides[0].classList.add('is-current');
      if (prev) prev.disabled = true;
      var gt = false;
      track.addEventListener('scroll', function () { if (!gt) { gt = true; requestAnimationFrame(function () { gt = false; syncGallery(); }); } }, { passive: true });
      if (prev) prev.addEventListener('click', function () { goTo(gi - 1); });
      if (next) next.addEventListener('click', function () { goTo(gi + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
      // Click to zoom on computers, follow the mouse
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        slides.forEach(function (s) {
          s.addEventListener('click', function (e) {
            s.classList.toggle('is-zoom');
            move(e, s);
          });
          s.addEventListener('mousemove', function (e) { if (s.classList.contains('is-zoom')) move(e, s); });
          s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
        });
      }
    }
    function move(e, s) {
      var r = s.getBoundingClientRect();
      var img = s.querySelector('img');
      if (!img) return;
      img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
      img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
    }
    function currentImg() { var s = slides[gi] || slides[0]; return s && s.querySelector('img'); }

    /* ---------- Buy box ---------- */
    var cta = $('[data-kp-cta]');
    var ctaLabel = $('[data-kp-cta-label]');
    var ctaPrice = $('[data-kp-cta-price]');
    var errEl = $('[data-form-error]');
    var stickyPrice = $('[data-kp-sticky-price]');
    var mode = $('[data-kp-opt]') ? 'deal' : (pickCount ? 'bulk' : 'plain');
    var qtyInput = $('[data-kp-qty-input]');

    // Deal builder
    var self = null;
    try { self = JSON.parse(($('[data-kp-self]') || {}).textContent || 'null'); } catch (e) {}
    var picks = self ? [self] : [];
    var slotsEl = $('[data-kp-slots]');
    var setMsg = $('[data-kp-set-msg]');
    var lastNew = -1;
    var subEl = $('.kp__set-sub');
    var subText = subEl ? subEl.textContent : '';

    function renderSet() {
      if (!slotsEl) return;
      var html = '';
      for (var i = 0; i < need; i++) {
        var p = picks[i];
        if (p) {
          html += '<span class="kp__slot is-filled' + (i === lastNew ? ' is-new' : '') + '">' +
            (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '') +
            '<span class="kp__slot-name">' + esc(p.name) + '</span>' +
            '<button type="button" class="kp__slot-x" data-kp-unpick="' + i + '" aria-label="Remove ' + esc(p.name) + '"><svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="3"/></svg></button></span>';
        } else {
          html += '<span class="kp__slot"><span class="kp__slot-n">' + (i + 1) + '</span></span>';
        }
      }
      slotsEl.innerHTML = html;
      lastNew = -1;
      var left = need - picks.length;
      if (setMsg) {
        setMsg.textContent = left > 0 ? 'Pick ' + left + ' more' : 'All set. You save ' + money(unit * need - dealPrice);
        setMsg.classList.toggle('is-done', left <= 0);
      }
      // Counts on the picker buttons
      $$('[data-kp-pick]').forEach(function (b) {
        var c = picks.filter(function (p) { return p.id === b.getAttribute('data-kp-pick'); }).length;
        var em = b.querySelector('em');
        if (c > 0) { if (!em) { em = document.createElement('em'); b.appendChild(em); } em.textContent = '×' + c; }
        else if (em) em.remove();
        b.classList.toggle('is-full', left <= 0);
      });
      if (subEl && self) {
        if (left > 0) subEl.innerHTML = esc(subText) + ' <button type="button" class="kp__fill" data-kp-fill>Or make it ' + need + ' × ' + esc(self.name) + '</button>';
        else subEl.textContent = subText;
      }
      updateCta();
    }

    function setMode(m) {
      mode = m;
      $$('[data-kp-opt]').forEach(function (o) {
        var on = o.getAttribute('data-kp-opt') === m;
        o.classList.toggle('is-on', on);
        var r = o.querySelector('input'); if (r) r.checked = on;
      });
      var set = $('[data-kp-set]'), single = $('[data-kp-single]');
      if (set) set.hidden = m !== 'deal';
      if (single) single.hidden = m !== 'single';
      updateCta();
    }

    // Plain products: options and price
    var variants = null;
    try { variants = JSON.parse(($('[data-kp-variants]') || {}).textContent || 'null'); } catch (e) {}
    var priceEl = $('[data-kp-price]');
    var currentVariant = null;
    if (variants && cta) currentVariant = variants.filter(function (v) { return String(v.id) === cta.getAttribute('data-variant'); })[0] || variants[0];
    function pickVariant() {
      if (!variants) return;
      var chosen = $$('[data-kp-option]').map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      currentVariant = variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null;
      $$('.kp__chip').forEach(function (c) { var i = c.querySelector('input'); c.classList.toggle('is-on', i.checked); });
      if (currentVariant) {
        cta.setAttribute('data-variant', currentVariant.id);
        if (priceEl) {
          var h = money(currentVariant.price);
          if (currentVariant.compare_at_price > currentVariant.price) h += '<s>' + money(currentVariant.compare_at_price) + '</s><span class="kp__save">Save ' + money(currentVariant.compare_at_price - currentVariant.price) + '</span>';
          priceEl.innerHTML = h;
        }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', currentVariant.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      updateCta();
    }

    // Bulk picker
    var bulkRows = $$('[data-kp-bulk-row]');
    function bulkTotal() { return bulkRows.reduce(function (s, r) { return s + (parseInt(r.querySelector('[data-kp-bcount]').textContent, 10) || 0); }, 0); }
    function renderBulk() {
      var t = bulkTotal();
      var msg = $('[data-kp-bulk-msg]'), bar = $('[data-kp-bulk-bar]');
      if (msg) { msg.textContent = t + ' of ' + pickCount + ' picked'; msg.classList.toggle('is-done', t === pickCount); }
      if (bar) bar.style.width = Math.min(t / pickCount, 1) * 100 + '%';
      bulkRows.forEach(function (r) {
        var c = parseInt(r.querySelector('[data-kp-bcount]').textContent, 10) || 0;
        r.classList.toggle('is-on', c > 0);
        r.querySelector('[data-kp-bplus]').disabled = t >= pickCount;
        r.querySelector('[data-kp-bminus]').disabled = c === 0;
      });
      updateCta();
    }

    var subBox = $('[data-kp-sub]'), planSel = $('[data-kp-plan]');
    function subOn() { var r = subBox && subBox.querySelector('[data-kp-sub-on]'); return !!(r && r.checked && planSel && planSel.value && mode !== 'deal'); }
    function planPrice() { var o = planSel && planSel.options[planSel.selectedIndex]; return o ? parseInt(o.getAttribute('data-price'), 10) || 0 : 0; }
    if (subBox) subBox.addEventListener('change', function () {
      subBox.querySelectorAll('.kp__sub-opt').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
      if (planSel) planSel.hidden = !subOn();
      updateCta();
    });
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function updateCta() {
      if (!cta) return;
      var label = 'Add to basket', price = '', disabled = false;
      if (mode === 'deal') {
        var left = need - picks.length;
        if (left > 0) { label = 'Pick ' + left + ' more ' + (left === 1 ? 'scent' : 'scents'); disabled = true; price = ''; }
        else { label = 'Add ' + need + ' to basket'; price = '<s>' + money(unit * need) + '</s>' + money(dealPrice); }
      } else if (mode === 'single') {
        // Any 3 are on the deal, so 3 singles cost the same as the set (repeats: 6 for £40)
        var q = qty(), sets = Math.floor(q / need), full = unit * q, deal = full - sets * (unit * need - dealPrice);
        price = deal < full ? '<s>' + money(full) + '</s>' + money(deal) : money(full);
        var nudge = $('[data-kp-nudge]');
        if (nudge) {
          nudge.hidden = q >= need;
          var more = need - q, nt = nudge.firstChild;
          if (nt && nt.nodeType === 3 && more > 0) nt.textContent = 'Add ' + more + ' more and pay ' + money(dealPrice) + ' for ' + need + '. ';
        }
      } else if (mode === 'bulk') {
        var t = bulkTotal();
        if (t < pickCount) { label = 'Choose ' + (pickCount - t) + ' more'; disabled = true; }
        else { label = 'Add to basket'; price = money(currentVariant ? currentVariant.price : (parseInt(cta.getAttribute('data-price'), 10) || 0)); }
      } else if (currentVariant || cta.getAttribute('data-price')) {
        // Plain products (incl. hang-ups: buy 4, get the 5th free)
        var avail = currentVariant ? currentVariant.available : !cta.hasAttribute('disabled');
        var up = currentVariant ? currentVariant.price : (parseInt(cta.getAttribute('data-price'), 10) || 0);
        var qn = qty(), every = parseInt(root.getAttribute('data-free-every'), 10) || 0;
        var fullP = up * qn, dealP = up * (qn - (every ? Math.floor(qn / every) : 0));
        disabled = !avail;
        label = avail ? 'Add to basket' : 'Sold out';
        if (avail) price = dealP < fullP ? '<s>' + money(fullP) + '</s>' + money(dealP) : money(fullP);
      }
      if (subOn() && planPrice() && !disabled) { price = money(planPrice() * (mode === 'bulk' ? 1 : qty())); label = 'Subscribe'; }
      if (subBox) subBox.hidden = mode === 'deal';
      if (ctaLabel && !cta.classList.contains('is-added')) ctaLabel.textContent = label;
      if (ctaPrice) ctaPrice.innerHTML = price;
      cta.disabled = disabled;
      if (stickyPrice) stickyPrice.innerHTML = disabled ? label : ((mode === 'deal' || mode === 'bulk' || qty() < 2) ? '' : qty() + ' × ') + (price || '').replace(/<s>.*?<\/s>/, '');
    }

    // Clicks
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-kp-opt]');
      if (opt) { setMode(opt.getAttribute('data-kp-opt')); return; }
      if (e.target.closest('[data-kp-to-deal]')) { setMode('deal'); return; }
      var pick = e.target.closest('[data-kp-pick]');
      if (pick) {
        if (picks.length >= need) { pulse(slotsEl); return; }
        picks.push({ id: pick.getAttribute('data-kp-pick'), name: pick.getAttribute('data-name'), img: pick.getAttribute('data-img') });
        lastNew = picks.length - 1;
        flyTo(pick.querySelector('img'), lastNew);
        renderSet();
        return;
      }
      var un = e.target.closest('[data-kp-unpick]');
      if (un) { picks.splice(parseInt(un.getAttribute('data-kp-unpick'), 10), 1); renderSet(); return; }
      if (e.target.closest('[data-kp-fill]') && self) {
        while (picks.length < need) picks.push(self);
        lastNew = need - 1;
        renderSet();
        return;
      }
      if (e.target.closest('[data-kp-minus]') && qtyInput) { qtyInput.value = Math.max(1, qty() - 1); updateCta(); return; }
      if (e.target.closest('[data-kp-plus]') && qtyInput) { qtyInput.value = qty() + 1; updateCta(); return; }
      var bp = e.target.closest('[data-kp-bplus]'), bm = e.target.closest('[data-kp-bminus]');
      if (bp || bm) {
        var out = (bp || bm).closest('[data-kp-bulk-row]').querySelector('[data-kp-bcount]');
        var v = parseInt(out.textContent, 10) || 0;
        if (bp && bulkTotal() < pickCount) v++;
        if (bm && v > 0) v--;
        out.textContent = v;
        renderBulk();
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-kp-option]')) pickVariant();
      if (e.target === qtyInput) updateCta();
    });

    function pulse(el) { if (!el || reduce) return; el.classList.remove('k-shake'); void el.offsetWidth; el.classList.add('k-shake'); }

    function flyTo(img, index) {
      if (reduce || !img || !img.animate || !slotsEl) return;
      requestAnimationFrame(function () {
        var slot = slotsEl.children[index];
        if (!slot) return;
        var a = img.getBoundingClientRect(), b = slot.getBoundingClientRect();
        var g = document.createElement('div');
        g.className = 'k-fly';
        g.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;border-radius:14px;';
        g.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
        document.body.appendChild(g);
        slot.style.opacity = '0';
        g.animate([
          { transform: 'translate(0,0) scale(1)' },
          { transform: 'translate(' + (b.left - a.left) * 0.5 + 'px,' + ((b.top - a.top) * 0.5 - 40) + 'px) scale(' + (b.width / a.width * 0.8 + 0.2) + ')', offset: 0.5 },
          { transform: 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px) scale(' + (b.width / a.width) + ')' }
        ], { duration: 520, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { g.remove(); slot.style.opacity = ''; };
      });
    }

    // Add to basket
    function items() {
      if (mode === 'deal') {
        var counts = {};
        picks.forEach(function (p) { counts[p.id] = (counts[p.id] || 0) + 1; });
        return Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      }
      if (mode === 'bulk') {
        var list = bulkRows.map(function (r) { var c = parseInt(r.querySelector('[data-kp-bcount]').textContent, 10) || 0; return c ? r.getAttribute('data-name') + ' x' + c : null; }).filter(Boolean);
        var bi = { id: parseInt(cta.getAttribute('data-variant'), 10), quantity: 1, properties: { Scents: list.join(', ') } };
        if (subOn()) bi.selling_plan = parseInt(planSel.value, 10);
        return [bi];
      }
      var it = { id: parseInt((currentVariant && currentVariant.id) || cta.getAttribute('data-variant'), 10), quantity: qty() };
      if (subOn()) it.selling_plan = parseInt(planSel.value, 10);
      return [it];
    }

    if (cta) cta.addEventListener('click', function () {
      if (cta.disabled || cta.classList.contains('is-busy')) return;
      if (errEl) { errEl.textContent = ''; errEl.hidden = true; }
      cta.classList.add('is-busy');
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items(), sections: 'ajax-cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (res) {
        cta.classList.remove('is-busy');
        if (res && res.status) throw new Error(res.description || res.message || 'Could not add to basket.');
        var UI = window.KaoriUI || {};
        if (UI.refreshDrawer) UI.refreshDrawer(res.sections);
        if (UI.added) UI.added(cta);
        if (UI.flyToCart) UI.flyToCart(currentImg());
        document.dispatchEvent(new CustomEvent('kaori:cart-changed'));
        // Open the basket so the deal progress and checkout are right there
        setTimeout(function () {
          var icon = document.querySelector('.cart.header-icons-link');
          var drawer = document.querySelector('#ajax-cart-drawer[data-side-drawer]');
          if (icon && drawer) icon.click(); else window.location.href = root.getAttribute('data-cart');
        }, reduce ? 0 : 800);
        if (mode === 'deal' && self) { picks = [self]; setTimeout(renderSet, 900); }
      }).catch(function (e) {
        cta.classList.remove('is-busy');
        if (errEl) { errEl.textContent = e.message; errEl.hidden = false; }
      });
    });

    // Sticky bar on phones
    var sticky = $('[data-kp-sticky]');
    var stickyBtn = $('[data-kp-sticky-btn]');
    var buy = $('.kp__buy');
    if (sticky && cta && 'IntersectionObserver' in window) {
      var ctaVisible = true, buyAbove = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { ctaVisible = en.isIntersecting; buyAbove = en.boundingClientRect.top < 0; });
        var show = !ctaVisible && buyAbove;
        sticky.classList.toggle('is-shown', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('kp-sticky-on', show);
        stickyBtn.tabIndex = show ? 0 : -1;
      }, { threshold: 0 }).observe(cta);
      stickyBtn.addEventListener('click', function () {
        if (!cta.disabled) { cta.click(); return; }
        buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }

    if (mode === 'deal') { renderSet(); setMode('deal'); }
    else if (mode === 'bulk') renderBulk();
    else updateCta();
  }

  function boot() { document.querySelectorAll('[data-kp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-kp]'); if (r) init(r); });
})();
